module.exports = __webpack_public_path__ + "static/media/check-blue.83eb5ef1.svg";